module.exports = {
  content: ['./src/**/*.{ts,tsx}'],
  theme: {
    extend: {
      boxShadow: {
        pink: '0 0 20px 0 #DC32AD',
        ['pink-inset']: '0 0 35px 0 #DC32AD inset',
      },
      backgroundImage: {
        'global-background-grid': `url('${process.env.NEXT_PUBLIC_ASSET_PREFIX ?? ''}/images/grid.png')`,
        'global-background-maintenance': `url('${
          process.env.NEXT_PUBLIC_ASSET_PREFIX ?? ''
        }/images/maintenance.png')`,
      },
      borderWidth: {
        0.5: '0.5px',
      },
      colors: {
        normal: {
          1: '#FFF',
          2: 'rgba(255,255,255,153)',
          inactive: 'rgba(255,255,255,102)',
        },
        primary: {
          textActive: '#00FBEC',
          buttonBase: '#DC32AD',
          buttonBaseHover: '#FF69E1',
          error: '#DC3258',
        },
        gradient: {
          cardTop: '#00000033',
          cardBottom: '#805BE7',
          cardHoverTop: '#00000033',
          cardHoverBottom: '#805BE733',
          headerLeft: '#5EF9F926',
          headerRight: '#825deb26',
        },
        menuBg: 'rgba(0,0,0,0.5)',
        neutral: {
          930: '#141414',
          990: '#0c0c0c',
        },
        neon: {
          blue: '#00FBEC',
        },
        akiverse: {
          blue: '#00FBEC',
          pink: '#DC32AD',
          teras: '#DEE139',
          akir: '#00FBEC',
          akv: '#BD00FF',
          yellow: '#FCFF54',
        },
        dialogBg: 'rgba(0,0,0,0.5)',
        newsCategory: {
          EVENT: '#F59F1F',
          PROMO: '#28CD6A',
          INFO: '#DC325B',
        },
      },
    },
  },
}
